export type LoginFormValues = {
  username: string;
  password: string;
  rememberDevice: boolean;
  mfaEnabled?: boolean;
  mfaType?: string;
  mfaCode?: string;
  sso: {
    enabled: boolean;
    isLoading: boolean;
    loginFormType: LoginFormType;
  };
};

export enum LoginFormType {
  INTAKE = 'intake',
  EMAIL = 'email',
  SSO = 'sso',
}
